import LeftSectionBlock from "../../components/LeftSectionBlock";
import RightSectionBlock from "../../components/RightSectionBlock";
import InfoSecVideo from "../../assets/videos/information-security.mp4";

const MainContent = () => {
  return (
    <video className="infosec-iframe-blk" controls>
      <source src={InfoSecVideo} type="video/mp4" />
    </video>
  );
};

const InformationSecurity = () => {
  return (
    <div className="main-container-blk">
      <div className="main-section-blk">
        <LeftSectionBlock />
        <RightSectionBlock
          title="INFORMATION TECHNOLOGY"
          stringBlurb=" At iCXeed, we take information security seriously and prioritise
      protecting our clients' information. Our robust measures include a
      zero-trust policy, state-of-the-art encryption for data at rest
      and in transit, regular security audits, and penetration testing.
      We also provide comprehensive employee training on security best
      practices and comply with international standards."
          previousBtn="/training"
          nextBtn="/philippine-holidays"
          mainContent={<MainContent />}
        />
      </div>
    </div>
  );
};

export default InformationSecurity;
